import { useState, useEffect, useContext } from "react";
import { Checkbox, Row, Col, message, Result, Button } from "antd";
import { useStaffActions } from "@iso/actions/staffSetting.actions";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Page from "component/Page/index";
import Loading from "../Loading";
import { useStoreManagerActions } from "@iso/actions/storeManager.actions";
import { UserContext } from "../../context/UserContext";

const CustomStyle = styled.div`
   .ant-checkbox-wrapper {
      margin-bottom: 8px;
   }
`;

const AssignStore = () => {
   const staffActions = useStaffActions();
   const storeActions = useStoreManagerActions();
   const [checkedListDict, setCheckedListDict] = useState({});
   const [dataDetail, setDataDetail] = useState();
   const [stores, setStores] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const { id } = useParams();
   const { user, reloadStores, isLoading: isUserLoading } = useContext(UserContext);

   const getData = async () => {
      setIsLoading(true);
      try {
         const resGet = await staffActions.getStaffById(id);
         setDataDetail(resGet);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   };

   async function getStore() {
      setIsLoading(true);
      try {
         const resGet = await storeActions.getAllStore();
         setStores(resGet.data?.items || []);
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   }

   async function getStoreMember() {
      setIsLoading(true);
      try {
         const resGet = await storeActions.getAllStoreMemberByUserId(id);
         if (resGet.items?.length) {
            let _checkListDict = { ...checkedListDict };
            resGet.items.forEach((item) => {
               _checkListDict[item.storeId] = true;
            });

            setCheckedListDict(_checkListDict);
         }
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false);
      }
   }

   useEffect(() => {
      getData();
      getStore();
      getStoreMember();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const handleSelectStore = async (id, storeId) => {
      try {
         let checkResult = await staffActions.getStoreMember(id, storeId);
         if (!checkResult?.items?.length) {
            await staffActions.addStoreMember(id, {
               storeId,
               userId: id,
            });
            let _checkedListDict = { ...checkedListDict };
            _checkedListDict[storeId] = true;
            setCheckedListDict(_checkedListDict);
            message.success("Assign store success!", [0.5]);
         } else {
            let promises = checkResult.items.map((item) => {
               return staffActions.deleteStoreMemberById(item.id);
            });
            await Promise.all(promises);

            let _checkedListDict = { ...checkedListDict };
            _checkedListDict[storeId] = false;
            setCheckedListDict(_checkedListDict);
            message.success("Remove store success!", [0.5]);
         }

      } catch (error) {
         console.log(error);
      } finally {
         await reloadStores();
      }
   };

   return isLoading || isUserLoading || !user?.permissions ? (
      <Loading />
   ) : user && user.permissions?.["BackOfficeMenu.IAM.Staffs.AssignStore"] ? (
      <Page title="Assign Store">
         <div className="assign-store-wrapper">
            <Row className="px-6 py-8 mb-12 bg-white-0 rounded-sm shadow-sm">
               <Col span={8}>
                  <h3 className="mb-0">{dataDetail?.name || "-"}</h3>
               </Col>
               <Col span={8}>
                  <h3 className="mb-0">{dataDetail?.email || "-"}</h3>
               </Col>
               <Col span={8}>
                  <h3 className="mb-0">{dataDetail?.phoneNumber || "-"}</h3>
               </Col>
            </Row>
            <hr />
            <h2 className="my-7">Store list</h2>
            <div className="px-6 py-8 bg-white-0 rounded-sm shadow-sm">
               <CustomStyle>
                  <Checkbox.Group
                     style={{ width: "100%" }}
                     value={Object.entries(checkedListDict)
                        .filter(([_, value]) => value)
                        .map(([key]) => key)}
                     onChange={(e) => {
                        console.log("e1", e);
                     }}
                  >
                     <Row>
                        {stores.length > 0
                           ? stores.map((item) => (
                                <Col span={8} key={item.id}>
                                   <Checkbox
                                      checked={checkedListDict[item.id]}
                                      value={item.id}
                                      onClick={(e) =>
                                         handleSelectStore(id, e.target.value)
                                      }
                                   >
                                      <h4 className="capitalize my-4">
                                         {item?.name}
                                      </h4>
                                   </Checkbox>
                                </Col>
                             ))
                           : ""}
                     </Row>
                  </Checkbox.Group>
               </CustomStyle>
            </div>
         </div>
      </Page>
   ) : (
      <Result
         status="403"
         title="403"
         subTitle="Sorry, you don't have allowance to access this page"
         extra={<Button type="primary">Back Home</Button>}
      />
   );
};

export default AssignStore;
